import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes: routes
});

router.onError((error) => {
  try {
    if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes("Importing a module script failed")) {
      router.go(0);
    }
  }
  catch (e) {
    console.log(e);
  }
});

export default router;